module.exports = __webpack_public_path__ + "img/charecterist-img.56ea7048.png";